import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../api';
import tokens from '../theme/tokens';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem');
      return;
    }

    const senhaRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!newPassword.match(senhaRegex)) {
      setError("Senha deve conter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e números")
      return;
    }

    try {
      setLoading(true);
      const response = await api.post(`confirmresetpassword`, { token, newPassword });
      setLoading(false);
      setSuccess(response.data.message);
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setLoading(false);
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        setError(error.response.data.message);
      } else if (error.response && error.response.status === 500) {
        setError(error.response.data.error);
      } else {
        setError('Erro inesperado! Contate o suporte.');
      }
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, background: `linear-gradient(135deg, ${tokens.color.ink}, ${tokens.color.inkSoft})` }}>
      <Card component="form" onSubmit={handleSubmit} sx={{ width: '100%', maxWidth: 420, p: { xs: 3, sm: 4 } }}>
        <Box component="img" src="/logo_rfc.png" alt="Riviera FC" sx={{ width: 96, display: 'block', mx: 'auto', mb: 2 }} />
        <Typography variant="h5" align="center">Redefinir senha</Typography>
        <Typography color="text.secondary" align="center" sx={{ mb: 3 }}>Escolha uma nova senha para sua conta.</Typography>
        <Stack spacing={2}>
          <TextField label="Nova senha" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required fullWidth helperText="Mínimo 8 caracteres com maiúsculas, minúsculas e números" />
          <TextField label="Confirmar nova senha" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required fullWidth />
          {error && <Alert severity="error">{error}</Alert>}
          {success && <Alert severity="success">{success}</Alert>}
          <Button type="submit" variant="contained" size="large" disabled={loading}>
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Redefinir senha'}
          </Button>
        </Stack>
      </Card>
    </Box>
  );
};

export default ResetPassword;
